export default __webpack_public_path__ + "static/media/pexels-photo-6303659.ff28cbdc.jpeg";